import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/sales/list", {
    type: "referrer",
    ...params,
  });
};

export const exportCsv = async (params) => {
  return await fetchFinance("/sales/list", {
    type: "referrer",
    output: "csv",
    ...params,
  });
};

export const changeReferrer = async (params) => {
  return await fetchFinance("/action", {
    action: "updateReferrer",
    ...params,
  });
};

export const createReferrer = async (params) => {
  return await fetchFinance("/action", {
    action: "updateReferrer",
    ...params,
  });
};

export const updateCommission = async (params) => {
  return await fetchFinance("/action", {
    action: "updateReferrerCommission",
    ...params,
  });
};
